<template>
    <div class="main-container">
        <Header/>
        <!-- 内容区 -->
        <router-view></router-view>
        <Footer/>
    </div>
</template>

<script>
    import Header from "@/views/header.vue"
    import Footer from "@/views/bottom.vue"
    export default {
        components: {
            Header,
            Footer
        },
        data() {
            return {
            }
        },
        methods: {
        },
        mounted() {},
    }
</script>

<style lang="less" scoped>
    
</style>
